import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["carrier", "state"]

  connect() {
    // Store initial filter values
    this.updateFilters()
  }

  updateFilters() {
    // Get current filter values from the form elements
    const carrier = this.carrierTarget?.value || ""
    const state = this.stateTarget?.value || ""

    // Store all filter values on the controller element for the reflex to access
    this.element.dataset.carrierValue = carrier
    this.element.dataset.stateValue = state
  }

  filterChanged(event) {
    // Update filters immediately before the reflex fires
    this.updateFilters()
    // The reflex will read from the updated data attributes
  }
}

